export const agentRequests = {
  page: {
    filters: {
      accommodation: "Property",
      type: "Type",
    },
    subtitle: "What your guests have asked for through the agent.",
    clearFilters: "Clear filters",
    loadMore: "Load more",
    empty: "No requests yet.",
    emptyFiltered: "No requests match these filters.",
    columns: {
      type: "Type",
      guest: "Guest",
      asks: "Request",
      channel: "Channel",
      status: "Status",
      when: "When",
      amount: "Amount",
    },
  },
  // La columna Importe: en qué quedó el cobro de cada solicitud.
  amount: {
    paid: "Paid",
    awaiting: "Awaiting payment",
    property: "Pay at the property",
    void: "Not charged",
    quote: "Offered",
  },
  common: {
    title: "AI Front Desk Requests",
  },
  widget: {
    iaBadge: "AI",
    subtitle: "What your guests have asked for through the agent.",
    todayOn: "Showing today's only",
    todayOff: "Show only today's requests",
    today: "Today",
    entersToday: "Arrives today",
    entersTodayTitle: "This booking arrives today",
    test: "test",
    approve: "Approve",
    otherTime: "Another time",
    prioritize: "Prioritize",
    reject: "Reject",
    dismiss: "Dismiss from panel",
    loading: "Loading requests…",
    empty: "No requests yet.",
    emptySub: "When a guest asks for a late checkout, early check-in or extra nights, it will appear here.",
    viewAll: "View all requests",
    entryTime: "Check-in time",
    cancel: "Cancel",
    rejectIrreversible: "This action can't be undone.",
    modal: {
      approveTitle: "Approve the request?",
      approveTimeTitle: "Approve at another time?",
      tentativeTitle: "Prioritize this arrival?",
      rejectTitle: "Reject the request?",
      defaultTitle: "Confirm?",
      approveText: "You're about to approve the early check-in for",
      approveTimeText: "You'll confirm check-in at the time you set for",
      tentativeText: "We'll tell them you'll do everything you can to have it ready by then, although it depends on the previous checkout and the cleaning. It will be sent to",
      rejectText: "You're about to reject the early check-in for",
      defaultText: "Confirm for",
      approveCta: "Yes, approve",
      approveTimeCta: "Confirm time",
      tentativeCta: "Yes, notify",
      rejectCta: "Yes, reject",
      defaultCta: "Confirm",
    },
  },
  drawer: {
    close: "Close",
    allAccommodations: "All accommodations",
    allTypes: "All types",
    today: "Today",
    yesterday: "Yesterday",
    from: "From",
    to: "To",
    clear: "Clear",
    writeWhatsapp: "Message on WhatsApp",
    noMessages: "No saved messages for this chat.",
    pause: "Pause",
    play: "Play",
    downloadMp3: "Download MP3",
    viewReservation: "View booking",
    loading: "Loading…",
    emptyFiltered: "No requests match these filters.",
    end: "No more requests.",
    features: {
      early: "Early check-in",
      late: "Late checkout",
      extend: "Extend stay",
      invoice: "Invoice",
      handoff: "Action required",
      callMessage: "Call messages",
    },
    channels: {
      call: "Call",
    },
  },
  box: {
    rooms: "{count} room | {count} rooms",
    nights: "{count} night | {count} nights",
    guests: "{count} guest | {count} guests",
    earlyRequestedTitle: "Early check-in requested",
    arrivalRequestedTitle: "Arrival time requested",
    early: "Early",
    arrives: "Arrives",
  },
};
